/**
 * Whether announcing `nextCreatedAt` would move the social round pointer
 * FORWARD (or is unprovable, which we allow).
 *
 * `raceChanged`'s rotation branch trusts its callers: it files the outgoing
 * round's bets into `previousBets` for any round that is neither the current
 * nor the immediately-previous one. Handing it an OLDER round therefore rolls
 * the pointer backwards and wipes the live round's bets — shipped in `e57eacdf`,
 * closed in `5753824e` (v1.0.173).
 *
 * Two callers need this guard and must not diverge:
 *   - `raceUpdated` — a late `race:updated` for a round older than the ones we
 *     fetched is also "unknown" to `raceChanged`.
 *   - `setCurrentGame` — driven by a Supabase READ-REPLICA fetch (`<ref>-all`)
 *     ordered created_at desc, re-run on visibilitychange / focus / pageshow /
 *     online. A replica trailing the socket by a round hands us a stale round
 *     every time the player tabs back in.
 *
 * Absence means direction cannot be PROVEN, and we allow the move. The only
 * caller without a `createdAt` is the `lightning:revealed` partial, which is by
 * construction the live round — announcing it is either a no-op (pointer
 * already correct) or the repair we want. ISO-8601 UTC strings order correctly
 * under lexicographic comparison, so no Date parsing is needed.
 */
export const movesPointerForward = (
  nextCreatedAt: string | undefined,
  pointerCreatedAt: string | undefined
): boolean => !nextCreatedAt || !pointerCreatedAt || nextCreatedAt > pointerCreatedAt
